import React from "react";

const QrCodeField = ({ value, onChange, error = "" }) => (
    <div>
        <label
            htmlFor="qrCode"
            className="block text-right font-custom mb-1 font-medium"
        >
            (اختیاری) QR شناسه یکتا  
        </label>
        <input
            id="qrCode"
            name="qrCode"
            type="text"
            dir="ltr"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "qrCode-error" : undefined}
            className={`border rounded px-3 py-2 w-full ${
                error ? "border-red-500" : ""
            }`}
        />
        {error && (
            <p
                id="qrCode-error"
                className="mt-1 text-sm text-red-600 text-right font-custom"
                dir="rtl"
            >
                {error}
            </p>
        )}
    </div>
);

export default QrCodeField;
